import { forwardRef } from 'react';

import { IconProps } from '.';

export const PlusIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        fill="currentColor"
        d="M16.5 10.13V10.87C16.5 11.0689 16.421 11.2597 16.2803 11.4003C16.1397 11.541 15.9489 11.62 15.75 11.62H11.62V15.75C11.62 15.9489 11.541 16.1397 11.4003 16.2803C11.2597 16.421 11.0689 16.5 10.87 16.5H10.12C9.92189 16.4974 9.73263 16.4176 9.59253 16.2775C9.45244 16.1374 9.37259 15.9481 9.37 15.75V11.62H5.25C5.05109 11.62 4.86032 11.541 4.71967 11.4003C4.57902 11.2597 4.5 11.0689 4.5 10.87V10.13C4.5 9.93109 4.57902 9.74032 4.71967 9.59967C4.86032 9.45902 5.05109 9.38 5.25 9.38H9.38V5.25C9.38 5.05109 9.45902 4.86032 9.59967 4.71967C9.74032 4.57902 9.93109 4.5 10.13 4.5H10.87C11.0689 4.5 11.2597 4.57902 11.4003 4.71967C11.541 4.86032 11.62 5.05109 11.62 5.25V9.38H15.75C15.9489 9.38 16.1397 9.45902 16.2803 9.59967C16.421 9.74032 16.5 9.93109 16.5 10.13Z"
      />
    </svg>
  );
});

export default PlusIcon;
